"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class;

var ContentActivity = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(ContentActivity, _Activity);

  function ContentActivity() {
    babelHelpers.classCallCheck(this, ContentActivity);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ContentActivity).apply(this, arguments));
  }

  babelHelpers.createClass(ContentActivity, [{
    key: "contentSetup",
    value: function contentSetup() {
      var _this = this;

      this.addEventListener('startedActivity', this._contentActivityStarted);
      this.addEventListener('timerExpired', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();
      if (this.readOnly) this.activityComplete();
    }
  }, {
    key: "_contentActivityStarted",
    value: function _contentActivityStarted(event) {
      this.showActivityTitle();

      if (!this.readOnly) {
        if (event.activity.endTime) {
          this.startTimer(new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime(), true);
        } else if (event.activity.discussion) {
          this.endActivity();
        } else {
          this.startTimer(10 * 1000, true);
        }
      }
    }
  }]);
  return ContentActivity;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_contentActivityStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_contentActivityStarted"), _class.prototype)), _class);
exports.default = ContentActivity;